import React from 'react';
import { LanguageType } from 'types/enums';

/**
 * The shell now provides the top-level navbar (logo, main tabs,
 * notifications, user menu, logout).  This slim version only renders
 * the page-specific left/right action components that callers pass in
 * (e.g. save / delete / close buttons on the entry form).
 */

interface Props {
	leftComponent?: React.ReactNode | null;
	rightComponent?: React.ReactNode | null;
	onLogoClick?: () => void;
	fullWidth?: boolean;
}

export function HeaderMain({ leftComponent, rightComponent }: Props) {
	if (!leftComponent && !rightComponent) return null;

	return (
		<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
			{leftComponent && <div>{leftComponent}</div>}
			{rightComponent && <div>{rightComponent}</div>}
		</div>
	);
}

const BASE_SUPPORT_URL = 'https://support.ledidi.no';
export const baseSupportUrlForLanguage = (language: LanguageType) => {
	switch (language) {
		case LanguageType.English:
			return `${BASE_SUPPORT_URL}/en`;
		case LanguageType.Norwegian:
			return `${BASE_SUPPORT_URL}/nb-NO`;
		default:
			return BASE_SUPPORT_URL;
	}
};
